export default {
    forms: [],
    pagination: {
        page: 1,
        rowsPerPage: 10
    },
    totalItems: 0
}
